"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const base_1 = __importDefault(require("../../client/buttons/base"));
const custom_1 = __importDefault(require("../../client/form_components/checkboxes/custom"));
const DragAndDropList_1 = __importDefault(require("../../client/reusable_components/DnDKit/DragAndDropList"));
const icon_1 = __importDefault(require("../../client/icon"));
const error_handler_1 = __importDefault(require("../../services/error_handler"));
const graphql_1 = require("../../requests/graphql");
const dispatchers_1 = require("../../utility/dispatchers");
const user_helpers_1 = require("../../utility/user_helpers");
const layout_css_1 = __importDefault(require("../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../styles/global_ui/util.css"));
const c = {
    header: `${typography_css_1.default.h2Responsive}`,
    container: `${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter22}`,
    draggableContainer: `${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter15} ${layout_css_1.default.marginTop30} `,
    draggable: `${layout_css_1.default.flexCenterItems} ${layout_css_1.default.flexJustifySpaceBetween} ${layout_css_1.default.padding5} ${util_css_1.default.bgSkyToHalfHackster} ${util_css_1.default.tertiaryBorder} ${util_css_1.default.borderRadius}`,
    disabled: `${util_css_1.default.disabled}`,
};
const PrizeItem = ({ attributes, item, listeners, }) => (react_1.default.createElement("div", { ...attributes, className: c.draggable, ...listeners },
    react_1.default.createElement("p", { className: `${typography_css_1.default.bodyM} ${typography_css_1.default.bold} ${typography_css_1.default.lakeToWhite}` }, item.name),
    react_1.default.createElement(icon_1.default, { className: `${typography_css_1.default.lakeToWhite}`, name: "sort-dots", size: "16" })));
const RegisterTab = ({ giveawayId, isRegistered, setIsRegistered, setActiveTab, prizes, title, url, user, }) => {
    const filteredPrizes = prizes.filter(({ prize_type }) => prize_type !== 'grand');
    const [orderedPrizes, setOrderedPrizes] = (0, react_1.useState)(filteredPrizes);
    const [agreed, setAgreed] = (0, react_1.useState)(isRegistered);
    const grandPrize = prizes.find(({ prize_type }) => prize_type === 'grand');
    const { tier } = user;
    const handleRegister = () => {
        const preferences = orderedPrizes.map((prize) => prize.id);
        (0, graphql_1.graphMutate)({ t: 'create_giveaway_registration' }, { giveaway_id: giveawayId, prize_preferences: preferences })
            .then(({ registration }) => {
            // If there isn't a registration id, they were presented with login modal.
            if (registration?.id) {
                (0, dispatchers_1.summonGlobalMessenger)({
                    msg: "You've been registered!",
                    type: 'success',
                });
                setIsRegistered(!isRegistered);
                setActiveTab('surveys');
            }
        })
            .catch((err) => {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: JSON.parse(err.response.text).errors[0],
                type: 'error',
            });
            (0, error_handler_1.default)('Giveaway Dashboard handleSubmit Error: ', err);
        });
    };
    const updatePrizeOrder = (prizeOrder) => {
        setOrderedPrizes(prizeOrder);
    };
    return (react_1.default.createElement("div", { className: c.container },
        react_1.default.createElement("h2", { className: c.header },
            "Register for",
            ' ',
            react_1.default.createElement("span", null, title)),
        react_1.default.createElement("p", null,
            "Enter now for your chance to win",
            ' ',
            grandPrize?.name || orderedPrizes[0].name,
            ".",
            ' ',
            grandPrize?.description,
            ' ',
            react_1.default.createElement("a", { href: `${url}?view=prizes` }, "Learn more.")),
        react_1.default.createElement("form", { className: c.container },
            react_1.default.createElement("label", { className: typography_css_1.default.charcoal },
                react_1.default.createElement(icon_1.default, { className: layout_css_1.default.marginRight5, name: "arrows-down-up", size: "16" }),
                "Rank the following weekly prizes by those you are most interested in winning.",
                react_1.default.createElement("p", { className: typography_css_1.default.bodyM }, "If your name is drawn, we will do our best to honour your top ranked choice."),
                react_1.default.createElement(DragAndDropList_1.default, { ItemComponent: PrizeItem, classNames: {
                        container: c.draggableContainer,
                        item: isRegistered ? c.disabled : '',
                    }, dragEndCallback: updatePrizeOrder, hasDragHandle: true, isDisabled: isRegistered, items: orderedPrizes })),
            react_1.default.createElement("div", { className: `${layout_css_1.default.flexJustifySpaceBetween} ${layout_css_1.default.gutter10}` },
                react_1.default.createElement("div", { className: layout_css_1.default.alignSelfCenter },
                    react_1.default.createElement("div", { className: `${layout_css_1.default.flexCenterItems} ${layout_css_1.default.gutter10}` },
                        react_1.default.createElement(custom_1.default, { isChecked: agreed, name: "agree", onChange: () => setAgreed(!agreed) }),
                        react_1.default.createElement("label", { className: `${layout_css_1.default.margin0} ${typography_css_1.default.bodyM}` },
                            "I agree to the",
                            ' ',
                            react_1.default.createElement("a", { href: `${url}?view=rules`, rel: "noreferrer", target: "_blank" }, "Terms and Conditions"))),
                    !(0, user_helpers_1.isPendingOrVerified)(tier) && react_1.default.createElement("div", { className: `${typography_css_1.default.bodyS} ${typography_css_1.default.error}` }, "Don't forget to get verified! You will need to be verified before you can win a prize. Check your email for details after registering.")),
                react_1.default.createElement(base_1.default, { disabled: isRegistered || !agreed, onClick: handleRegister, size: "md" }, isRegistered ? 'Registered!' : 'Register')))));
};
exports.default = RegisterTab;
